var React = require('react');

function Attention (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","fillRule":"evenodd","stroke":"#000","strokeLinecap":"round","strokeWidth":"2","d":"M49 25c0 13.255-10.745 24-24 24S1 38.255 1 25 11.745 1 25 1s24 10.745 24 24zM25 9.327v22.53m2.449 6.857a2.449 2.449 0 1 1-4.898 0 2.449 2.449 0 0 1 4.898 0z"}));
}

Attention.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50"};

module.exports = Attention;

Attention.default = Attention;
